import { render } from "./GemeindeSearch.vue?vue&type=template&id=97524260"
import script from "./GemeindeSearch.vue?vue&type=script&lang=js"
export * from "./GemeindeSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/Components/GemeindeSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97524260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97524260', __exports__)) {
    api.reload('97524260', __exports__)
  }
  
  module.hot.accept("./GemeindeSearch.vue?vue&type=template&id=97524260", () => {
    api.rerender('97524260', render)
  })

}


export default __exports__